// Multivariate Dependencies
import React, { forwardRef } from 'react';
// Components
import { Container } from '../../../common/styles/container/styles/Container';
import { IconContainer } from '../styles/IconContainer';
import { Paragraph } from '../../../atoms/Paragraph';
import { PrefixedDropdownListOptionLabelContainer } from '../styles/PrefixedDropdownListOptionLabelContainer';
import { PrefixLabel } from '../../../atoms/PrefixLabel/styles/PrefixLabel';
// Hooks
import { useTheme } from 'styled-components';
/**
 * @deprecated Since version 0.7.3, use `DropdownItem` component
 */
export var PrefixedDropdownListOption = forwardRef(function (_a, ref) {
    var dropdownOption = _a.dropdownOption, onMouseEnter = _a.onMouseEnter, onClick = _a.onClick, onMouseLeave = _a.onMouseLeave, onMouseMove = _a.onMouseMove;
    var themeStyles = useTheme();
    return (React.createElement(Container, { className: 'keepFocusOnDropdownInput', tabIndex: -1, ref: ref, backgroundColor: themeStyles.backgroundUI, display: 'grid', gridTemplateColumns: 'fit-content(20px) auto', padding: '2px', cursor: 'pointer', outline: 'none', onClick: function () { return onClick(dropdownOption); }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove },
        React.createElement(Container, { gridColumn: '1', width: '20px', height: 'calc(100% - 2px)', display: 'flex', justifyContent: 'center', paddingTop: '2px' },
            React.createElement(IconContainer, { ariaLabel: '', name: dropdownOption.icon })),
        React.createElement(PrefixedDropdownListOptionLabelContainer, { gridColumn: '2' },
            React.createElement(Paragraph, { size: 'xsmall' },
                React.createElement(PrefixLabel, { styleVariant: 'grey' }, dropdownOption.prefixLabel),
                dropdownOption.label))));
});
//# sourceMappingURL=PrefixedDropdownListOption.js.map